import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserParkingSpot from './UserParkingSpot';
import {closeDrawer} from '../../actions/navOptions';
import {logOutUser} from '../../utils';
import AvatarImage from '../AvatarImage';

class UserInfoDrawer extends Component {

  renderParkingSpotsLimitMessage() {
    const {qualifiedSpots} = this.props;
    const suffix = (qualifiedSpots === 1) ? "1 spot" : `${qualifiedSpots} spots`;

    return (
      <div className="panel panel-empty">
        <i className="fa fa-circle color-danger" />&nbsp;{`You can choose up to ${suffix}`}
      </div>
    );
  }

  renderAvailableSpotsMessage(noOfAvailableSpots) {
    const suffix = (noOfAvailableSpots > 1) ? `${noOfAvailableSpots} more spots` : "1 more spot";

    return (
      <span>
        <i className="fa fa-info-circle color-primary" />
        &nbsp;You can choose up to {suffix}.
      </span>
    );
  }

  renderSpots() {
    const {qualifiedSpots, reservedSpots, isReadOnly} = this.props;
    const noOfAvailableSpots = qualifiedSpots - reservedSpots.length;

    const userParkingSpots = reservedSpots.map((spotName, index) => {
      return <UserParkingSpot key={index} spotIdentifier={spotName} isReadOnly={isReadOnly} />;
    });

    return(
      <div>
        <strong>
          <small>
            MY SPOTS
          </small>
        </strong>
        <div>
          { noOfAvailableSpots > 0 && this.renderAvailableSpotsMessage(noOfAvailableSpots) }
          {userParkingSpots}
        </div>
      </div>
    );
  }

  render() {
    const {reservedSpots, closeDrawer, firstName, lastName, email, avatar} = this.props;

    return (
      <div id="drawer" className="drawer">
        <a className="close-it close-it-alt" href="#" onClick={closeDrawer}>&times;</a>

        <div className="profile-head">
          <AvatarImage entity="drawer" avatar={avatar} style={{width: '40px', height: '40px'}}  />
          <strong>{`${firstName} ${lastName}`}</strong>
          {email}
        </div>

        <div className="profile-content">
          {reservedSpots.length === 0 ? this.renderParkingSpotsLimitMessage() : this.renderSpots() }
        </div>

        <ul>
          <li><a onClick={logOutUser} href="#" tabIndex="-1">Logout</a></li>
        </ul>
      </div>
    );
  }

}

const mapStateToProps = (state) => (
  {
    qualifiedSpots: state.userAccommodationInfo.qualifiedSpots,
    reservedSpots: state.userAccommodationInfo.reservedSpots,
    email: state.user.email,
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    avatar: state.user.avatar
  }
);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeDrawer }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInfoDrawer);



// WEBPACK FOOTER //
// ./src/containers/UserInfoDrawer/index.js